module.exports = __webpack_public_path__ + "static/media/27OCHA11.7119348b.jpg";